import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import DataHandler from "@/components/functional/DataHandler.vue";
import { useRoute,useRouter } from "vue-router";
import {watch} from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
watch(route, (to) => {
  //@ts-ignore
  document.title = to.meta.title || 'Game Medizinsammlung'
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DataHandler),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})